import { State } from '../state';
import { createSelector, MemoizedSelector } from '@ngrx/store';
import { selectBpmnProcessState } from './bpmn-process-state.selector';
import { BpmnDeploymentIdentifier } from '@ispm-shared/modules/bpmn';

const getBpmnDeploymentIdentifier = (state: State): any => state.bpmnDeploymentIdentifier;
const getBpmnXmlDeploymentId =
  (bpmnDeploymentIdentifier: BpmnDeploymentIdentifier): any => bpmnDeploymentIdentifier ? bpmnDeploymentIdentifier.deploymentId : null;
const getBpmnProcessId =
  (bpmnDeploymentIdentifier: BpmnDeploymentIdentifier): any => bpmnDeploymentIdentifier ? bpmnDeploymentIdentifier.processId : null;

export const selectBpmnDeploymentIdentifier: MemoizedSelector <
  object,
  BpmnDeploymentIdentifier
  > = createSelector(selectBpmnProcessState, getBpmnDeploymentIdentifier);

export const selectBpmnProcessDeploymentId: MemoizedSelector<
  object,
  string
  > = createSelector(
  selectBpmnDeploymentIdentifier, getBpmnXmlDeploymentId);

export const selectBpmnProcessId: MemoizedSelector<
  object,
  string
  > = createSelector(selectBpmnDeploymentIdentifier, getBpmnProcessId);

